<template>
    <div class="page comrade-detail">

        <column-skeleton v-if="loading" style="margin-bottom: 100vh"></column-skeleton>

        <video v-if="comrade.type===2" id="my-video" class="video-js vjs-default-skin vjs-big-play-centered" controls preload="none" x5-playsinline="" webkit-playsinline="" playsinline="" :poster="comrade.cover_img" x-webkit-airplay="true"></video>

        <div class="comrade-detail-box">
            <h3 class="comrade-detail-title">{{comrade.title}}</h3>
            <div style="padding: 0 15px 15px">
                <div class="comrade-detail-time">{{comrade.created_at}} 阅读 {{comrade.view_count}}</div>
            </div>
            <div class="clear" style="margin-top: 15px"></div>

            <div v-if="comrade.type ===1 && comrade.article">
                <div class="comrade-detail-content">
                    <div class="rich_media_inner" v-html="comrade.article.content"></div>
                </div>
            </div>
            <div v-if="comrade.type ===2 && comrade.video">
                <div class="comrade-detail-content">
                    <div class="rich_media_inner" v-html="comrade.video.content"></div>
                </div>
            </div>
        </div>

        <div class="comment" style="margin-top: 10px">
            <div class="comment-title">评论</div>
            <div class="comment-section" v-for="item in comment" :key="item.id">
                <div class="comment-section-photo">
                    <img :src="item.avatar" alt="">
                </div>
                <div class="comment-section-content">
                    <div class="comment-section-content-author" @click="reComment(item)">{{item.name}}</div>
                    <div class="comment-section-content-detail" @click="reComment(item)">{{item.content}}</div>
                    <div class="comment-section-content-bottom">
                        <div class="comment-section-content-time">{{item.created_at}}</div>
                        <div class="comment-section-content-point" @click="pointLikeComment(item)">
                            <span v-if="item.isLike"><van-icon name="/static/img/course/icon_course_like_on.svg" /></span>
                            <span v-else><van-icon name="/static/img/course/icon_course_like_off.svg" /></span>
                            {{item.like_count == 0 ? '赞' : item.like_count}}
                        </div>
                        <div class="clear"></div>
                        <div class="comment-section-content-children" v-if="item.children != null && item.children.length > 0">
                            <div v-for="val in item.children"> <span @click="reCommentChild(val)">{{val.name}}</span><span style="color: #404040" v-if="val.reply_name != ''"> 回复 </span><span @click="reCommentChild(val)">{{val.reply_name}}</span>：{{val.content}}</div>
                        </div>
                    </div>
                </div>
                <div class="clear"></div>
            </div>
        </div>

        <div class="comrade-detail-footer">
            <div class="comrade-detail-footer-box">
                <div :class="'comrade-detail-footer-left '+ (comment_text!=''?'comment_in':'')">
                    <van-field round
                               left-icon="/static/img/course/icon_course_text.svg"
                               v-model="comment_text"
                               @click="checkUserLogin"
                               :placeholder="comment_placeholder">
                    </van-field>
                </div>
                <div :class="'comrade-detail-footer-right '+ (comment_text!=''?'comment_in':'')">
                    <van-grid :column-num="3" :border="false" v-if="comment_text == ''">
                        <van-grid-item @click="favorite()" v-if="comrade.isFavorite" icon="/static/img/course/icon_course_favorite_on_20.svg" text="已收藏" />
                        <van-grid-item @click="favorite()" v-else icon="/static/img/course/icon_course_favorite_off_20.svg" text="收藏" />
                        <van-grid-item @click="pointLike()" v-if="comrade.isLike" icon="/static/img/course/icon_course_like_on.svg" text="点赞" :badge="comrade.like_count"/>
                        <van-grid-item @click="pointLike()" v-else icon="/static/img/course/icon_course_like_off.svg" text="点赞" :badge="comrade.like_count"/>
                        <van-grid-item @click="openShareData" icon="/static/img/course/icon_course_share_20.svg" text="转发" />
                    </van-grid>
                    <div class="comrade-detail-footer-right-btn" v-else>
                        <van-button type="danger" size="medium" @click="createComment" color="#0FB7AD">
                            发送
                        </van-button>
                    </div>
                </div>
            </div>
            <van-number-keyboard safe-area-inset-bottom />
        </div>

        <van-overlay class-name="overlay" :show="showShareDialog" @click="showShareDialog = false" style="z-index: 999">
            <div class="share-box">
                <div class="block">
                    请点击 “...”，再点击发送给朋友 | <span>知道啦</span>
                </div>
                <div class="share-box-bottom">
                    <img src="/static/bytx/detail_forward_2_img.png" alt="">
                </div>
            </div>
        </van-overlay>
    </div>
</template>

<script>
    import Interface from "@/util/interface"
    import videojs from "video.js";
    import columnSkeleton from "@/skeleton/columnSkeleton"
    import checkLogin from "../../../mixins/checkLogin";
    export default {
        name: 'comrade-detail',
        mixins:[checkLogin],
        components :{
            'column-skeleton' : columnSkeleton
        },
        data() {
            return {
                id:"",
                comrade:{},
                comment:[],
                downloads:[],
                related:[],
                value: "",
                active: "",
                tab:0,
                comment_text:"",
                comrade_img_visible : true,
                loading:true,
                share_data :{},
                showShareDialog:false,
                htmlUrl:"",
                isShow:false,
                status:"",
                showDownload:false,
                myPlayer:"",
                comment_id :0,
                to_user_id:0,
                comment_placeholder:"写评论",
                user_id:0
            }
        },
        methods:{
            async fetch(scene){
                if (scene === 'comrade') {
                    Interface.getData('get', Interface.comrade.detail+this.id).then((res) => {
                        this.comrade = res.data
                        document.title = this.comrade.title
                        if(this.comrade){
                            Interface.getShareInfo(this,this.comrade.title,this.comrade.cover_img,"")
                        }
                        if(this.comrade.type == 1 && this.comrade.article.need_auth == 1){
                            this.addInfo('article')
                        }

                        if(res.data.type === 2 && res.data.video){
                            Interface.getData('get', Interface.video_info + '/' + res.data.video.video_id).then((resp) => {
                                let videoUrl;
                                resp.data.PlayInfoList.PlayInfo.forEach((val)=>{
                                    if(val.Format == 'mp4'){
                                        videoUrl = val.PlayURL
                                    }
                                })
                                const myPlayerOptions = {
                                    bigPlayButton: true,
                                    textTrackDisplay: true,
                                    posterImage: true,
                                    errorDisplay: true,
                                    controlBar: true,
                                    autoplay:false,
                                    controls: true,
                                }
                                this.comrade_img_visible = false
                                setTimeout(() => {
                                    let _this = this
                                    this.myPlayer = videojs('my-video', myPlayerOptions,function onPlayerReady(){
                                        this.on("play", function(){
                                            //检测登录
                                            setTimeout(()=>{
                                                if(_this.comrade.video.need_auth === 1){
                                                    let user = localStorage.getItem("user");
                                                    user = JSON.parse(user)
                                                    if (user.new_reg_complete !== 1){
                                                        this.pause()
                                                        _this.showAddConfirm()
                                                    }
                                                }
                                            },10000)
                                        });
                                    })
                                    this.myPlayer.src(videoUrl)
                                    this.myPlayer.load(videoUrl)


                                    setTimeout(()=>{
                                        this.loading = false
                                    },500)
                                }, 500)
                            });
                        }else{
                            setTimeout(()=>{
                                this.loading = false
                            },500)
                        }
                    })
                }else if (scene === 'comment') {
                    let params = {
                        content_id : this.id,
                        comment_type:10,
                        page:1,
                        pageSize:999
                    }
                    Interface.getData('get', Interface.comment,params).then((res) => {
                        if(res.code == 0 && res.data.list != null){
                            this.comment = res.data.list
                        }
                    })
                }else if (scene === 'footprint') {
                    let params = {
                        id : this.id,
                        type:10,
                    }
                    Interface.getData('post', Interface.footprint,params).then((res) => {

                    })
                }else if (scene === 'share') {
                    let params = {
                        content_id : this.id,
                        type:1,
                    }
                    Interface.getData('get', Interface.share,params).then((res) => {
                        this.share_data = res.data
                        this.htmlUrl = res.data.post_img_url
                    })
                }
            },
            reComment(item){
                this.comment_placeholder = '回复'+item.nickname
                this.comment_id = item.id
            },
            reCommentChild(item){
                this.comment_placeholder = '回复'+item.nickname
                this.comment_id = item.comment_id
                this.to_user_id = item.user_id
            },
            favorite(){
                Interface.getData('get', Interface.comrade.favorite+this.id).then((res) => {
                    if(res.code == 0){
                        this.comrade.isFavorite = !this.comrade.isFavorite
                    }
                })
            },
            goComment(){
                this.tab = 1;
            },
            createComment(){

                if(!this.userLoginCheck()){
                    return
                }

                this.tab = 1
                if (this.comment_text == ""){
                    return;
                }
                let params = {
                    content_id:this.id,
                    comment_type:10,
                    content:this.comment_text,
                }
                if(this.comment_id != 0){
                    params.comment_id = +this.comment_id
                }
                if(this.to_user_id != 0){
                    params.to_user_id = +this.to_user_id
                }
                Interface.getData('post', Interface.comment,params).then((res) => {
                    if(res.code == 0){
                        this.$toast.success("评论成功")
                        this.comment_text = ""
                        this.comment_placeholder = "写评论"
                        this.comment_id=0
                        this.to_user_id=0
                        this.fetch('comment')
                        this.goComment()
                    }
                })
            },
            go_detail(item){
                if (item.type === 2){
                    this.$router.push({'name':'comrade-column',params:{id:item.id}})
                } else {

                    let params = {
                        content_id : this.id,
                        progress:1,
                        type:1
                    }
                    var currentTime = parseInt(this.myPlayer.currentTime())
                    var duration = this.myPlayer.duration()
                    params.progress = parseInt( (currentTime / duration * 100).toFixed(0));
                    Interface.getData('get', Interface.progress,params).then((res) => {})
                    this.tab = 0
                    this.$router.push({name:'comrade-detail',params: { id: item.id }})
                }
            },
            pointLike() {
                Interface.getData('get', Interface.comrade.like + this.id).then((res) => {
                    if (res.code == 0) {
                        this.comrade.isLike = !this.comrade.isLike
                        this.comrade.like_count = !this.comrade.isLike ? parseInt(this.comrade.like_count) - 1 : parseInt(this.comrade.like_count) + 1
                        this.$forceUpdate()
                    }
                })
            },

            pointLikeComment(item){
                Interface.getData('get', Interface.pointLikeComment+item.id).then((res) => {
                    if(res.code == 0){
                        item.isLike = !item.isLike
                        if (item.isLike){
                            item.like_count += 1
                        }else{
                            item.like_count -= 1
                        }
                    }
                })

            },
            openShareData(){
                this.showShareDialog = true
            },
            checkUserLogin(){
                this.userLoginCheck()
            },
        },
        created(){
            this.id = this.$route.params.id
            this.fetch('comrade')
            this.fetch('comment')
            this.fetch("footprint")
            this.fetch('share')
        },
        watch: {
            async $route(to, from) {
                this.loading = true
                this.id = this.$route.params.id
                this.fetch('comrade')
                this.fetch('comment')
                this.fetch("footprint")
            }
        },
        destroyed() {
            if(this.myPlayer){
                let params = {
                    content_id : this.id,
                    progress:1,
                    type:1
                }
                var currentTime = parseInt(this.myPlayer.currentTime())
                var duration = parseInt(this.myPlayer.duration())
                if (isNaN(duration)){
                    params.progress = 0
                }else{
                    params.progress = parseInt( (currentTime / duration * 100).toFixed(0));
                }
                Interface.getData('get', Interface.progress,params).then((res) => {})
                this.myPlayer.dispose()
            }
        },
    }
</script>

<style lang="scss">
    @import "./index.scss";
    .van-overlay{
        z-index: 999 !important;
    }
</style>



// WEBPACK FOOTER //
// src/views/comrade/detail/index.vue